import { useRange } from 'react-instantsearch-core';

export const DummyRangeActivator = () => {
  useRange({ attribute: 'price' });
  return null;
};
